import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../components/home'
import Layout from '../components/layout';
import About from '../components/about/about';
import Parent from '../components/parent';
import Transparency from '../components/transparency';
import TransparencyDetail from '../components/transparency/transparency-detail';
import Program from '../components/program';
import HumanResources from '../components/transparency/hr';
import Register from '../components/register';
import Login from '../components/login';
import Profile, { UserProfile } from '../components/profile';
import Eelj from '../components/eelj';
import Payment from '../components/payment';
import EeljDetail from '../components/eelj/EeljDetail';
import NewsDetail from '../components/news/news-detail';
import News from '../components/news';
import ServiceDetail from '../components/service/service-detail';
import GroupList from '../components/grouplist';
import PrivacyPolicy from '../components/privacy/PrivacyPolicy';
import EbookList from '../components/ebook';
import EbookDetail from '../components/ebook/ebook-detail';
import EbookPayment from '../components/ebook/ebook-payment';
import EbookReader from '../components/ebook/ebook-reader';
import CampPrograms from '../components/en/CampPrograms';
import Events from '../components/en/Events';
import Gallery from '../components/en/Gallery';
import Facilities from '../components/en/Facilities';
import ContactPage from '../components/en/Contact';
// import Ticket from '../components/ticket/ticket';

export default function WebRoutes(props: any) {
  return (
    <Layout>
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/`} element={<Home/>} />
        <Route path={`${process.env.PUBLIC_URL}/about`} element={<About/>} />
        <Route path={`${process.env.PUBLIC_URL}/parent`} element={<Parent/>} />
        <Route path={`${process.env.PUBLIC_URL}/transparency`} element={<Transparency/>} />
        <Route path={`${process.env.PUBLIC_URL}/transparency/:id`} element={<TransparencyDetail/>} />
        <Route path={`${process.env.PUBLIC_URL}/program`} element={<Program/>} />
        <Route path={`${process.env.PUBLIC_URL}/hr`} element={<HumanResources/>} />
        <Route path={`${process.env.PUBLIC_URL}/register`} element={<Register/>} />
        <Route path={`${process.env.PUBLIC_URL}/login`} element={<Login/>} />
        <Route path={`${process.env.PUBLIC_URL}/profile`} element={<UserProfile/>} />
        <Route path={`${process.env.PUBLIC_URL}/profile/:id`} element={<Profile/>} />
        <Route path={`${process.env.PUBLIC_URL}/eelj`} element={<Eelj/>} />
        <Route path={`${process.env.PUBLIC_URL}/eelj/:id`} element={<EeljDetail/>} />
        <Route path={`${process.env.PUBLIC_URL}/payment/:id`} element={<Payment/>} />

        <Route path={`${process.env.PUBLIC_URL}/news`} element={<News/>} />
        <Route path={`${process.env.PUBLIC_URL}/news/:id`} element={<NewsDetail/>} />
        
        <Route path={`${process.env.PUBLIC_URL}/service/:id`} element={<ServiceDetail/>} />
        <Route path={`${process.env.PUBLIC_URL}/grouplist`} element={<GroupList/>} />

        

        <Route path={`${process.env.PUBLIC_URL}/ebook`} element={<EbookList/>} />
        <Route path={`${process.env.PUBLIC_URL}/ebook/:id`} element={<EbookDetail/>} />
        <Route path={`${process.env.PUBLIC_URL}/ebook/payment/:id`} element={<EbookPayment/>} />
        <Route path={`${process.env.PUBLIC_URL}/ebook/read/:id`} element={<EbookReader/>} />

        <Route path={`${process.env.PUBLIC_URL}/privacy`} element={<PrivacyPolicy/>} />

        {/* EN-only pages */}
        <Route path={`${process.env.PUBLIC_URL}/camp-programs`} element={<CampPrograms/>} />
        <Route path={`${process.env.PUBLIC_URL}/events`} element={<Events/>} />
        <Route path={`${process.env.PUBLIC_URL}/gallery`} element={<Gallery/>} />
        <Route path={`${process.env.PUBLIC_URL}/facilities`} element={<Facilities/>} />
        <Route path={`${process.env.PUBLIC_URL}/contact`} element={<ContactPage/>} />

        
        {/* <Route path={`${process.env.PUBLIC_URL}/ticket/:id`} element={<Ticket/>} /> */}

        {/* <Route path={`${process.env.PUBLIC_URL}/*`} element={<h1>Хуудас олдсонгүй</h1>} /> */}
      </Routes>
    </Layout>
  )
}